const cognitoAuthConfig = {
  authority: process.env.REACT_APP_COGNITO_AUTHORITY,
  client_id: process.env.REACT_APP_COGNITO_CLIENT_ID,
  redirect_uri: process.env.REACT_APP_INTERNAL_PORTAL_URL,
  response_type: "code",
  scope: "email openid profile",
};

export default cognitoAuthConfig;
